export default __webpack_public_path__ + "images/mailchimp.d6b52221962a9819b55b836be9fe065c.png";